import es from './es.json';
import LocalizationEntity from '../../../../../../domain/entities/LocalizationEntity';

const LocalizationList: LocalizationEntity[] = [
    {
        name: 'spanish',
        code: 'es',
        dictionary: es,
        image: 'https://cdn.countryflags.com/thumbs/spain/flag-round-250.png'
    }
];

export default LocalizationList;